/**
 * Module-level store for pending photo File objects.
 *
 * File objects cannot be serialized into Redux or localStorage,
 * so we keep them in memory and mirror them to IndexedDB for
 * persistence across page reloads.
 */
import { set, get } from "idb-keyval";

const IDB_KEY = "mikey_pending_photos";

let pendingPhotos = [];
let writeQueue = Promise.resolve();

function persistToIDB() {
  writeQueue = writeQueue
    .then(() => set(IDB_KEY, pendingPhotos))
    .catch(() => {});
}

export function getPendingPhotos() {
  return [...pendingPhotos];
}

export function setPendingPhotos(photos) {
  pendingPhotos = [...photos];
  persistToIDB();
}

export function addPendingPhotos(newPhotos) {
  pendingPhotos = [...pendingPhotos, ...newPhotos];
  persistToIDB();
}

export function removePendingPhoto(index) {
  pendingPhotos = pendingPhotos.filter((_, i) => i !== index);
  persistToIDB();
}

export function clearPendingPhotos() {
  pendingPhotos = [];
  writeQueue = writeQueue.then(() => set(IDB_KEY, [])).catch(() => {});
}

/**
 * Restore photos from IndexedDB into the in-memory store.
 * Returns the restored array (empty if nothing was persisted).
 */
export async function restorePhotosFromIDB() {
  try {
    const stored = await get(IDB_KEY);
    if (Array.isArray(stored) && stored.length > 0) {
      pendingPhotos = stored;
      return [...pendingPhotos];
    }
  } catch {
    // IndexedDB unavailable — no-op
  }
  return [];
}
